// Schedule list view — day-grouped, time-sorted, with heart toggles + search.

import { store } from "../state/store";
import type { FestSet } from "../data/schedule";
import { setsForDay, findConflicts } from "../data/schedule";
import { fmtBlockTime } from "../lib/time";
import { searchMatches } from "../lib/slug";

export function mountScheduleList(host: HTMLElement, allSets: FestSet[]): void {
  function render() {
    const s = store.get();
    const sets = setsForDay(allSets, s.day).filter(p => s.stages.includes(p.stage));
    const conflicts = new Set<string>();
    const faveSets = sets.filter(p => s.faves.has(p.id));
    findConflicts(faveSets).forEach(([a, b]) => {
      conflicts.add(a.id);
      conflicts.add(b.id);
    });
    const filtered = s.search ? sets.filter(p => searchMatches(s.search, p.artist) || searchMatches(s.search, p.stage)) : sets;

    host.innerHTML = `
      <div class="sched-wrap">
        <div class="sched-header">
          <input type="search" class="sched-search" placeholder="Search artists or stages…" value="${escape(s.search)}" />
          <div class="sched-stats">
            <span><strong>${faveSets.length}</strong> fave${faveSets.length === 1 ? "" : "s"}</span>
            ${conflicts.size > 0 ? `<span class="conflict-warn">⚠ ${conflicts.size / 2} conflict${conflicts.size / 2 === 1 ? "" : "s"}</span>` : ""}
          </div>
        </div>
        <div class="sched-rows">
          ${filtered.map(p => rowHTML(p, s.faves.has(p.id), conflicts.has(p.id))).join("")}
        </div>
      </div>
    `;

    host.querySelector<HTMLInputElement>(".sched-search")!.addEventListener("input", e => {
      store.update({ search: (e.target as HTMLInputElement).value });
    });
    host.querySelectorAll<HTMLElement>(".sched-row").forEach(row => {
      row.addEventListener("click", () => {
        const id = row.dataset.id!;
        store.toggleFave(id);
      });
    });
  }

  function rowHTML(p: FestSet, isFave: boolean, isConflict: boolean): string {
    const conflictClass = isConflict ? " conflict" : "";
    const faveClass = isFave ? " fav" : "";
    const closerBadge = p.isCloser ? `<span class="row-closer">CLOSER</span>` : "";
    const setBadge = p.badge ? `<span class="row-badge">${p.badge}</span>` : "";
    return `
      <div class="sched-row${faveClass}${conflictClass}" data-id="${p.id}">
        <div class="row-time">${fmtBlockTime(p.startUTC)}</div>
        <div class="row-info">
          <div class="row-artist">${escape(p.artistDisplay)} ${setBadge}</div>
          <div class="row-stage" style="color:${p.stageColor};">
            <span class="row-stage-dot" style="background:${p.stageColor};"></span>
            ${p.stage} ${closerBadge}
          </div>
        </div>
        <button class="row-heart ${isFave ? "active" : ""}" aria-label="${isFave ? "Unfavorite" : "Favorite"}">${isFave ? "♥" : "♡"}</button>
      </div>
    `;
  }

  store.subscribe(render);
  render();
}

function escape(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
